import React, { useContext, useEffect, useRef, forwardRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { SvgArrow } from 'components/Svgs';
import { DropdownContext } from 'features/App/Contexts';
import { bem } from 'helpers/class-name';
import { selectIsDesktop } from 'selectors/ui';

import './DropdownItem.scss';

const { block, element } = bem('dropdown-item2');

const DropdownItemWrapper = forwardRef(function DropdownItem(props, ref) {
  const {
    className,
    onClick,
    onSelect,
    children,
    id,
    isSelected,
    isTitle,
    isHighlighted,
    fallbackSelectedItemRef,
    ...rest
  } = props;
  const isDesktop = useSelector(selectIsDesktop);
  const { showMenuCaret, toggleMenu } = useContext(DropdownContext);

  let buttonRef = useRef();
  if (ref) {
    buttonRef = ref;
  } else if (fallbackSelectedItemRef && isSelected) {
    buttonRef = fallbackSelectedItemRef;
  }

  const [isFirstChild, setIsFirstChild] = useState(false);

  useEffect(() => {
    if (buttonRef.current && buttonRef.current.parentElement) {
      setIsFirstChild(buttonRef.current.parentElement.firstChild === buttonRef.current);
    }
  }, [buttonRef]);

  function handleClick() {
    onClick?.();
    if (onSelect) onSelect();
  }

  return (
    <button
      id={id}
      type="button"
      role="option"
      aria-selected={isSelected}
      className={block(className, { isSelected, isHighlighted, isTitle, isItem: !isTitle })}
      onClick={handleClick}
      ref={buttonRef}
      {...rest}>
      {children}
      {showMenuCaret && isFirstChild && isDesktop && (
        <SvgArrow className={element('caret-icon')} direction="up" onClick={event => toggleMenu(event)} />
      )}
    </button>
  );
});

DropdownItemWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  fallbackSelectedItemRef: PropTypes.shape({ current: PropTypes.node }),
  id: PropTypes.string,
  isHighlighted: PropTypes.bool,
  isSelected: PropTypes.bool,
  isTitle: PropTypes.bool,
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
};

export default DropdownItemWrapper;
